import { render, staticRenderFns } from "./sfq.vue?vue&type=template&id=473ab18f&scoped=true&"
import script from "./sfq.vue?vue&type=script&lang=js&"
export * from "./sfq.vue?vue&type=script&lang=js&"
import style0 from "./sfq.vue?vue&type=style&index=0&id=473ab18f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ab18f",
  null
  
)

export default component.exports